import { render, staticRenderFns } from "./ComboBoxMenuItemObject.vue?vue&type=template&id=00fd8048&scoped=true&"
import script from "./ComboBoxMenuItemObject.vue?vue&type=script&lang=ts&"
export * from "./ComboBoxMenuItemObject.vue?vue&type=script&lang=ts&"
import style0 from "./ComboBoxMenuItemObject.vue?vue&type=style&index=0&id=00fd8048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fd8048",
  null
  
)

export default component.exports